import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilService, DialogService, NotificationService } from '../../../shared/index';
import { EventsService } from '../../../events/shared/events.service';
import { EventSponsorsService } from '../../../events/shared/sponsors/event-sponsors.service';
import { EventSponsor } from '../../../events/shared/sponsors/event-sponsor.model';
import { ProfileRead } from '../../../profiles/shared/profile-read.model';
import { AsyncState } from '../../../shared/model/index';
import { UserService } from '../../../users/shared/user.service';
import { TranslationService } from '../../../shared/translation/translation.service';
import { moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'wl-event-settings-sponsors',
  styleUrls: ['event-settings-sponsors.component.css'],
  templateUrl: 'event-settings-sponsors.component.html',
  providers: [EventsService, EventSponsorsService, UserService],
    standalone: false
})
export class EventSettingsSponsorsComponent implements OnInit {
  public _router: Router;
  public _route: ActivatedRoute;
  public _dialogService: DialogService;
  public _utilService: UtilService;
  public _eventService: EventsService;
  public _eventSponsorsService: EventSponsorsService;
  public _sponsorIdToDelete: number = 0;
  public _userService: UserService;

  public loadingSponsor: AsyncState = new AsyncState();

  public sponsors: Array<EventSponsor>;
  public eventId: number;
  public loadingSponsors: boolean = false;
  public loadingSponsorsError: string = '';
  public saving: boolean = false;
  public savingError: string = '';
  public deleting: boolean = false;
  public deleteError: string = '';
  public selectedSponsor: EventSponsor;
  public userAccessLevel: number;

  public showEditModal = false;
  public showDeleteModal = false;

  public constructor(
    router: Router,
    route: ActivatedRoute,
    dialogService: DialogService,
    utilService: UtilService,
    eventSponsorsService: EventSponsorsService,
    eventService: EventsService,
    userService: UserService,
    public _notificationService: NotificationService,
    public _translationService: TranslationService
  ) {
    this._router = router;
    this._route = route;
    this._dialogService = dialogService;
    this._utilService = utilService;
    this._eventSponsorsService = eventSponsorsService;
    this._eventService = eventService;
    this._userService = userService;

    this.sponsors = new Array<EventSponsor>();
    this.eventId = 0;
    this.selectedSponsor = new EventSponsor();
    this.userAccessLevel = 0;
  }

  public loadEventSponsors() {
    this.loadingSponsors = true;
    this.loadingSponsorsError = '';

    this._eventSponsorsService
      .getEventEventSponsors(this.eventId)
      .then((data: any) => {
        this.loadingSponsors = false;
        this.sponsors = data.Result;
        if (this.sponsors.length > 0) {
          this.selectedSponsor = this.sponsors[0];
        }
      })
      .catch(error => {
        this.loadingSponsors = false;
        this.loadingSponsorsError = this._utilService.extractErrorMessage(error);
      });
  }

  public newSponsor = (): void => {
    this.saving = false;
    this.savingError = '';

    this.loadingSponsor.busy = false;
    this.loadingSponsor.message = '';

    let newSponsor: EventSponsor = new EventSponsor();
    newSponsor.EventId = this.eventId;
    this.selectedSponsor = newSponsor;
    this.showEditModal = true;
  };

  public saveSponsors = (): void => {
    this.saving = true;
    this.savingError = '';

    this._eventSponsorsService
      .upsertEventSponsor(this.selectedSponsor)
      .then(() => {
        this.saving = false;
        this.loadEventSponsors();
        this.showEditModal = false;

        this._translationService
          .getTitlecase('events.settings.sponsors.save-success-message')
          .then(translation => this._notificationService.success(translation));
      })
      .catch(error => {
        this.saving = false;
        this.savingError = this._utilService.extractErrorMessage(error);
      });
  };

  public editSponsor = (sponserId: number): void => {
    this.saving = false;
    this.savingError = '';

    this.loadingSponsor.busy = true;
    this.loadingSponsor.message = '';
    this.loadingSponsor.success = false;

    this._eventSponsorsService
      .getEventEventSponsor(sponserId)
      .then(data => {
        this.loadingSponsor.busy = false;
        this.loadingSponsor.success = true;
        this.selectedSponsor = data;
        this.showEditModal = true;
      })
      .catch(error => {
        this.loadingSponsor.busy = false;
        this.loadingSponsor.message = this._utilService.extractErrorMessage(error);
        this.loadingSponsor.success = false;
      });
  };

  public confirmDeleteSponsor(sponsorId: number): void {
    this.deleting = false;
    this.deleteError = '';
    this._sponsorIdToDelete = sponsorId;
    this.showDeleteModal = true;
  }

  public deleteSponsor = (): void => {
    this.deleting = true;
    this.deleteError = '';

    this._eventSponsorsService
      .deleteEventSponsor(this._sponsorIdToDelete)
      .then(() => {
        this.deleting = false;
        this.showDeleteModal = false;
        this.loadEventSponsors();
      })
      .catch(error => {
        this.deleting = false;
        this.deleteError = this._utilService.extractErrorMessage(error);
      });
  };
  public sponsorProfileChanged = (profile: ProfileRead): void => {
    if (this.selectedSponsor.SponserId <= 0 && (profile && profile.ProfileId > 0)) {
      this.selectedSponsor.SponsorName = profile.ReportName;

      if (profile.Website)
        this.selectedSponsor.SponsorWebsite = /^https?:\/\//i.test(profile.Website.trim()) ? profile.Website : 'http://' + profile.Website;
    }
  };

  public sorted(event) {
    moveItemInArray(this.sponsors, event.previousIndex, event.currentIndex);
    this._eventSponsorsService.reorderEventSponsors(this.eventId, this.sponsors);
  }

  ngOnInit() {
    this._route.params.subscribe(params => {
      if (this._utilService.isNumeric(params['id'])) {
        let id = Number(params['id']);
        this.eventId = id;

        this.loadEventSponsors();
      }
    });

    this._userService.getCurrentUserSecurityElementAccessLevel('Events_Module').then((data: number) => {
      this.userAccessLevel = data;
    });
  }
}
